import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import Select from "react-select";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateDocumentType,
}) {
  const [update_modal_data, setUpdate_modal_data] = useState({
    _id: "",
    name: "",
    applicableTo: [],
  });

  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [errors, setErrors] = useState({});

  const applicableToOptions = [
    { value: "Vehicle", label: "Vehicle" },
    { value: "Client", label: "Client" },
    { value: "Lease", label: "Lease" },
  ];

  // Load selected document type
  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data({
        _id: select_data._id || "",
        name: select_data.name || "",
        applicableTo: Array.isArray(select_data.applicableTo)
          ? select_data.applicableTo.map((item) => ({
              value: item,
              label: item,
            }))
          : [],
      });
    }
  }, [select_data]);

  // Open / close modal
  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal?.modal_open || false);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
    setErrors({});
  };

  // Handle normal input
  const handleChange = (e) => {
    const { name, value } = e.target;

    setUpdate_modal_data((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Clear error while typing
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};

    if (!update_modal_data.name?.trim()) {
      newErrors.name = "Name is required.";
    }

    if (
      !update_modal_data.applicableTo ||
      update_modal_data.applicableTo.length === 0
    ) {
      newErrors.applicableTo = "Please select at least one applicable type.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // Update document type
  const handleUpdate = async () => {
    if (!validateForm()) {
      return;
    }

    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire("Unauthorized!");
      return;
    }

    try {
      const { _id } = update_modal_data;

      if (!_id) {
        Swal.fire("Update failed", "Document Type ID is not defined.", "error");
        return;
      }

      const data = {
        name: update_modal_data.name.trim(),
        applicableTo: update_modal_data.applicableTo.map((item) => item.value),
      };

      console.log("Updating Document Type:", data);

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/document-type/${_id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("Update response:", response.data);

      if (response.data.success) {
        Swal.fire(
          "Update success",
          "Document type updated successfully.",
          "success",
        );

        // Update parent table
        if (onUpdateDocumentType) {
          onUpdateDocumentType(response.data.type);
        }

        handleClose();
      } else {
        Swal.fire(
          "Update failed",
          response.data.message || "Unable to update document type.",
          "error",
        );
      }
    } catch (error) {
      console.error(
        "Error updating document type:",
        error.response?.data || error,
      );

      Swal.fire(
        "Update failed",
        error.response?.data?.message ||
          "Something went wrong while updating document type.",
        "error",
      );
    }
  };

  return (
    <Modal show={add_data_modal_Show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Document Type</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* Document Type Name */}
          <Form.Group className="mb-3" controlId="name">
            <Form.Label>
              <b>Document Type Name *</b>
            </Form.Label>

            <Form.Control
              type="text"
              name="name"
              placeholder="Document Type Name"
              value={update_modal_data.name || ""}
              onChange={handleChange}
              isInvalid={!!errors.name}
            />

            <Form.Control.Feedback type="invalid">
              {errors.name}
            </Form.Control.Feedback>
          </Form.Group>

          {/* Applicable To */}
          <Form.Group className="mb-3" controlId="applicableTo">
            <Form.Label>
              <b>Applicable To *</b>
            </Form.Label>

            <Select
              isMulti
              options={applicableToOptions}
              value={update_modal_data.applicableTo || []}
              onChange={(selectedOptions) => {
                setUpdate_modal_data((prevData) => ({
                  ...prevData,
                  applicableTo: selectedOptions || [],
                }));

                setErrors((prevErrors) => ({
                  ...prevErrors,
                  applicableTo: "",
                }));
              }}
              placeholder="Select applicable type..."
              closeMenuOnSelect={false}
            />

            {errors.applicableTo && (
              <div className="text-danger mt-1">{errors.applicableTo}</div>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={handleClose}>
          Close
        </Button>

        <Button variant="primary" size="sm" onClick={handleUpdate}>
          Update Document Type
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
